module.exports = __webpack_public_path__ + "static/media/birth-cert-step3.66b8a776.png";